import * as React from 'react'
import { SvgIconProps } from '.'

const SubMenuArrowDown: React.FC<SvgIconProps> = ({
  fill = 'var(--neutral-200)',
  width = 10,
  height = 10,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.56 7.186a1 1 0 0 1-1.267-.122L1.464 4.236A1 1 0 0 1 2.88 2.822l2.12 2.121 2.122-2.121a1 1 0 0 1 1.415 1.414L5.707 7.064a1.006 1.006 0 0 1-.146.122Z"
      fill="currentColor"
    />
  </svg>
)

export default SubMenuArrowDown
